var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16647 0.285706C7.54668 0.285706 8.66647 1.4055 8.66647 2.78571C8.66647 4.16591 7.54668 5.28571 6.16647 5.28571C4.78626 5.28571 3.66647 4.16591 3.66647 2.78571C3.66647 1.4055 4.78626 0.285706 6.16647 0.285706Z",
    fill: "#A4AFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1426 10.0903C11.1426 10.6488 10.7957 10.9524 9.79151 10.9524H2.20807C1.20385 10.9524 0.856934 10.6488 0.856934 10.0903C0.856934 8.53006 2.84713 6.38094 5.99979 6.38094C9.15854 6.38094 11.1426 8.53006 11.1426 10.0903Z",
    fill: "#A4AFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f7ef9a3cbefd8a48b31418017ebd6c3d.svg";
export { ForwardRef as ReactComponent };